export default __webpack_public_path__ + "static/media/clearReportData.cdc3d359.svg";